import { z } from 'zod';
/**
 * Moderation REST DTO — Phase 5 / Plan 05-04 (WIDGET-04).
 *
 * 엔드포인트 (스트리머 세션 전용, 본인 차단어 CRUD):
 *   - `GET    /api/v1/moderation/me/forbidden-words[?includeGlobal=true]` — 목록 조회
 *   - `POST   /api/v1/moderation/me/forbidden-words`                      — 추가
 *   - `DELETE /api/v1/moderation/me/forbidden-words/:id`                  — 삭제
 *
 * 불변:
 *   - 본인 row 만 CRUD (path 에 streamerId 없음 — session 의 streamerId 가 유일 소스).
 *   - word 는 최대 100자, category 최대 32자 + 소프트 검증 (app 레벨).
 *   - 중복 시 400 `already_exists` — DB unique violation 매핑.
 */
/** POST request body — word (필수) + category (optional, default 'custom'). */
export const addForbiddenWordRequestSchema = z.object({
    /** 원문 차단어. 사용자 입력 그대로 받되 서비스 레이어가 `normalizeForFilter` 적용. */
    word: z.string().min(1).max(100),
    /** 분류 태그. 기본 'custom'. 'profanity'·'hate_speech'·'spam'·'custom'. */
    category: z.string().min(1).max(32).optional(),
});
/** 단일 forbidden word 응답. */
export const forbiddenWordResponseSchema = z.object({
    id: z.string().uuid(),
    scope: z.enum(['global', 'streamer']),
    streamerId: z.string().uuid().nullable(),
    word: z.string().min(1).max(100),
    /** 정규화된 매칭 키 — 디버깅·프론트 hint 용도. */
    normalizedWord: z.string(),
    category: z.string(),
    createdAt: z.string().datetime({ offset: true }),
});
/** 목록 응답. */
export const listForbiddenWordsResponseSchema = z.object({
    items: z.array(forbiddenWordResponseSchema),
});
//# sourceMappingURL=moderation.rest.js.map